/**
 * Lyra Therapy (LT) Prescriber role configurations.
 */

import { BC_PRESCRIBER_CALENDAR, MINIMAL_CALENDAR } from './calendars'
import { RoleConfig } from './types'

/**
 * LT Prescriber configuration.
 */
export const LT_PRESCRIBER: RoleConfig = {
  sameDayBooking: true,
  bcPlatform: true,
  showOOOMessageTab: true,
  videoSessionsEnabled: true,
  medicationEnabled: true,
  zendeskWidget: false,
  requestPayment: false,
  directAccessClientList: false,
  helpCenterUrl: 'https://blended-care-physicians-hub.zendesk.com/hc/en-us',
  eligibilityChecker: false,
  utilizationEnabled: false,
  showMinifiedUtilization: true,
  showOverdueMessageFlag: true,
  showInPersonPrompt: false,
  smartSchedulingEnabled: false,
  hidePerformanceMetrics: false,
  showCloseSessionBanner: true,
  inProductCalendar: BC_PRESCRIBER_CALENDAR,
  showCareInsights: false,
}

/**
 * LT Clinical Leave Evaluator configuration.
 * Similar to Prescriber but does NOT have directAccessClientList property.
 */
export const LT_CLINICAL_LEAVE_EVALUATOR: RoleConfig = {
  sameDayBooking: true,
  bcPlatform: true,
  showOOOMessageTab: true,
  videoSessionsEnabled: true,
  medicationEnabled: true,
  zendeskWidget: false,
  requestPayment: false,
  // NOTE: directAccessClientList is intentionally NOT set (differs from LT_PRESCRIBER)
  helpCenterUrl: 'https://blended-care-physicians-hub.zendesk.com/hc/en-us',
  eligibilityChecker: false,
  utilizationEnabled: false,
  showMinifiedUtilization: true,
  showOverdueMessageFlag: true,
  showInPersonPrompt: false,
  smartSchedulingEnabled: false,
  hidePerformanceMetrics: false,
  showCloseSessionBanner: true,
  inProductCalendar: BC_PRESCRIBER_CALENDAR,
  showCareInsights: false,
}

/**
 * LT SAP Evaluator configuration.
 * Same as Clinical Leave Evaluator but without the Medication tab.
 */
export const LT_SAP_EVALUATOR: RoleConfig = { ...LT_CLINICAL_LEAVE_EVALUATOR, medicationEnabled: false }

/**
 * LT Prescriber Supervisor configuration.
 */
export const LT_PRESCRIBER_SUPERVISOR: RoleConfig = {
  zendeskWidget: false,
  eligibilityChecker: false,
  assessmentTrackSettingsEnabled: true,
  inProductCalendar: MINIMAL_CALENDAR,
}
